/**
 * Created by zhijie.huang on 2018/10/18.
 * 注册公共组件
 */

import gBack from '@/components/back'
import gSelect from '@/components/selectExtend'

export default function (Vue) {
  Vue.component(gBack.name, gBack)
  Vue.component(gSelect.name, gSelect)
}
